// extracted by mini-css-extract-plugin
export default {"UpgradeItems":"styles_UpgradeItems__V-uW1","roomTypes":"styles_roomTypes__MP1bz"};